/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { AbsoluteURL, UINotification } from '@poweralpha/common';
import { useCallback } from 'react';
import { useOptionalAgentPanel } from '../agent/AgentPanelContext';
import usePANavigate from '../react-components/navigate/usePANavigate';
import { opensInNotificationCenter } from './display';
import { useOptionalNotificationCenter } from './NotificationCenterContext';

// Takes the user to where a notification points: the agent panel for agent
// runs, the notification center for failed runs (logs are not user-facing),
// otherwise the page that owns the link.
export function useOpenNotification() {
  const { navigate } = usePANavigate();
  const agentPanel = useOptionalAgentPanel();
  const notificationCenter = useOptionalNotificationCenter();

  return useCallback(
    (notification: UINotification) => {
      const { link } = notification;
      if (link.startsWith('/agent') && agentPanel) {
        const conversationId = link.startsWith('/agent/') ? link.slice('/agent/'.length) : '';
        agentPanel.openAgentPanel(conversationId || undefined);
        return;
      }
      if (opensInNotificationCenter(link) && notificationCenter) {
        notificationCenter.openNotificationCenter(notification);
        return;
      }
      navigate(link as AbsoluteURL);
    },
    [agentPanel, navigate, notificationCenter],
  );
}
